// extracted by mini-css-extract-plugin
module.exports = {"PageContent":"PageContent--3MN7F"};